import React, { useContext } from "react";
import AutocompleteInput from "components/FormElements/AutocompleteInput";
import Label from "components/FormElements/Label";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as userTransformer } from "schemas/User";
import { AssignmentContext } from "context/Assignment";

export default function UserField(props) {
    const auth = useAuth();
    const { loading, performingStateChange, isUserEditable } =
        useContext(AssignmentContext);

    if (loading) {
        return (
            <div>
                <Label>Assigned Users</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    return (
        <AutocompleteInput
            label="Assigned Users"
            name="users"
            id="users"
            disabled={loading || performingStateChange || !isUserEditable}
            onRequestSearch={async (term) => {
                const items = await apiGet("/v4/search", auth.publication, {
                    keyword: term,
                    per_page: 5,
                    type: "user",
                });

                return userTransformer(items).map((item) => {
                    return {
                        label: item.name,
                        value: item.uuid,
                    };
                });
            }}
        />
    );
}
